export default "__VITE_ASSET__QUBpaHl8__"